import { useState, useEffect } from 'react';
import { useOkapiKy } from '@folio/stripes/core';

export default function useReportContext(location) {
  const okapiKy = useOkapiKy();

  const stateCtx = location?.state || {};
  const searchParams = new URLSearchParams(location?.search || '');
  const urlReportId  = searchParams.get('report_id');
  const urlIsRunMode = searchParams.get('run') === 'true';

  const reportId   = stateCtx.reportId  || urlReportId  || null;
  const isRunMode  = stateCtx.isRunMode  !== undefined ? stateCtx.isRunMode  : urlIsRunMode;
  const isEditMode = stateCtx.isEditMode !== undefined ? stateCtx.isEditMode : (!urlIsRunMode && !!urlReportId);

  // If state has the data already (normal nav) — no loading needed
  const hasStateData = !!stateCtx.reportId;

  const [reportName, setReportName]           = useState(stateCtx.reportName || null);
  const [reportDesc, setReportDesc]           = useState(stateCtx.reportDesc || null);
  const [defaultDisplayMethod, setDefaultDM] = useState(stateCtx.defaultDisplayMethod || 'table');
  const [displayMethods, setDisplayMethods]  = useState(stateCtx.displayMethods || []);
  const [returnSearch]                       = useState(stateCtx.returnSearch || '');
  // isContextLoading: true only when we need to fetch (after refresh)
  const [isContextLoading, setIsContextLoading] = useState(!hasStateData && !!reportId);

  useEffect(() => {
    if (!reportId) return;
    if (hasStateData) return; // already have data from state

    setIsContextLoading(true);
    okapiKy.get(`reports/${reportId}`).json()
      .then(report => {
        setReportName(report.name);
        setReportDesc(report.desc);
        setDefaultDM(report.visualization?.defaultDisplayMethod || 'table');
        setDisplayMethods(report.visualization?.displayMethods || []);
      })
      .catch(() => {})
      .finally(() => setIsContextLoading(false));
  }, [reportId]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    reportId,
    reportName,
    reportDesc,
    isRunMode,
    isEditMode,
    defaultDisplayMethod,
    displayMethods,
    returnSearch,
    isContextLoading,
  };
}
